import React from 'react';

import styled from 'styled-components';

import UnstyledButton from 'components/unstyled-button';
import { primitive } from 'styles/constants/primitives';

import theme from './theme';

const Container = styled.div`
  grid-area: more;

  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 0;
  padding-block-start: ${primitive.$spacing6};
  white-space: nowrap;

  ${Styles.desktop} {
    padding-block-start: 0;
    padding-block-end: ${primitive.$spacing4};
    padding-inline-start: ${primitive.$spacing1};
    padding-inline-end: 0;
  }
`;

const MoreOptionsButton = styled(UnstyledButton)`
  color: ${p => p.theme.token('text-button-secondary')};
  font: ${p => p.theme.token('text-style-button-small')};
  text-transform: ${theme.moreOptionsTextTransform};
  &:hover {
    text-decoration: underline;
  }
`;

interface IMoreOptions {
  openFilterModal: VoidFunction;
  buttonText: string;
}

export const MoreOptions: React.FC<IMoreOptions> = ({ openFilterModal, buttonText }) => {
  return (
    <Container>
      <MoreOptionsButton onClick={openFilterModal}>{buttonText}</MoreOptionsButton>
    </Container>
  );
};
